function timeout(delay) {
    return new Promise((res) => { return setTimeout(res, delay) })
}

export default timeout
